import { HubLabel } from '@core/interfaces/label';
import { DropdownValue } from '@shared/components/hub-dropdown-form-field/hub-dropdown';

/**
 * Sentinel value used in the label filter dropdown to represent
 * "items with no labels attached". Sent to the backend as `noneLabels=true`.
 */
export const NO_LABELS_FILTER_VALUE = 'none';

/**
 * Color used for the "None" entry in label filter dropdowns. Kept here so the
 * sentinel and its swatch stay together.
 */
export const NO_LABELS_FILTER_COLOR = '#BBBBBB';

export const NO_LABELS_DROPDOWN_OPTION: DropdownValue = {
  value: NO_LABELS_FILTER_VALUE,
  label: 'None',
  customNgStyle: `background-color: ${NO_LABELS_FILTER_COLOR}`,
};

export const toLabelDropdownOptions = (labels: HubLabel[]): DropdownValue[] => {
  const options: DropdownValue[] = labels.map((label) => ({
    value: label.id,
    label: label.name,
    customNgStyle: `background-color: ${label.color}`,
  }));
  options.unshift(NO_LABELS_DROPDOWN_OPTION);
  return options;
};

/**
 * Splits a list of selected dropdown values into the IDs of real labels and
 * the boolean "no-labels" flag. Returned shape mirrors the backend query params.
 */
export const splitLabelFilter = (
  selectedValues: string[],
): { labels: string[]; noneLabels: boolean } => ({
  labels: selectedValues.filter((value) => value !== NO_LABELS_FILTER_VALUE),
  noneLabels: selectedValues.includes(NO_LABELS_FILTER_VALUE),
});
